export default "__VITE_ASSET__BMU8pVZ8__"